import React from 'react'
import { Header2, Text } from '../../styles/Components'
import { TermsWrapper } from './TermsWrapper'

const SupportSection = ({ title, lastReviewedDate, content }) => {
  return (
    <TermsWrapper>
      <div className="content">
        <Header2 align="center" margin='0 0 10px 0'>{title}</Header2>
        <Text style={{ textAlign: 'center', color: '#878787' }}>
          Last revised on: {lastReviewedDate}
        </Text>

        <hr />
        <div className="copy" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </TermsWrapper>
  )
}

export default SupportSection
